import { render, staticRenderFns } from "./CallIpinAuthPop.vue?vue&type=template&id=08af32f2&scoped=true&"
import script from "./CallIpinAuthPop.vue?vue&type=script&lang=js&"
export * from "./CallIpinAuthPop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af32f2",
  null
  
)

export default component.exports